<template>

	<span>
		{{ translate(text, lang) }}
	</span>

</template>

<script>
	import { mapGetters } from "vuex";
	import { translateKey } from "@/services/Translate";

	export default {
		props:{
			"text":String
		},
		computed:{
			translatedText(){
				return this.translate(this.text, this.lang);
			},
			...mapGetters({
				lang:"localization/preferredLanguage"
			})
		},
		methods:{
			translate(v, lang){
				let result = translateKey(v, lang);
				return result ? result : v;
			}
		}
	}
</script>

<style>

</style>